import { render } from "./ReleasesPage.vue?vue&type=template&id=3e6e1c80&scoped=true"
import script from "./ReleasesPage.vue?vue&type=script&lang=js"
export * from "./ReleasesPage.vue?vue&type=script&lang=js"

import "./ReleasesPage.vue?vue&type=style&index=0&id=3e6e1c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6e1c80"]])

export default __exports__